import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-terms',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="terms">
      <div class="container">
        <header class="page-header">
          <h1>Terms of Service</h1>
          <p class="last-updated">Last Updated: {{ lastUpdated | date:'longDate' }}</p>
        </header>

        <div class="content">
          <div class="section">
            <h2>1. Introduction</h2>
            <p>
              Welcome to Industry Intelligence ("we," "our," or "us"). By accessing or using our services,
              you agree to be bound by these Terms of Service ("Terms"). Please read them carefully.
            </p>
          </div>

          <div class="section">
            <h2>2. Use of Services</h2>
            <h3>2.1 Account Registration</h3>
            <p>
              To access certain features of our services, you must register for an account.
              You agree to provide accurate and complete information during registration and
              to keep this information current.
            </p>

            <h3>2.2 Account Security</h3>
            <p>
              You are responsible for maintaining the confidentiality of your account
              credentials and for all activities that occur under your account.
            </p>
          </div>

          <div class="section">
            <h2>3. Subscription Terms</h2>
            <h3>3.1 Billing</h3>
            <ul>
              <li>Subscription fees are billed in advance on a recurring basis</li>
              <li>All fees are non-refundable unless otherwise stated</li>
              <li>You may cancel your subscription at any time</li>
            </ul>

            <h3>3.2 Changes to Fees</h3>
            <p>
              We reserve the right to modify our subscription fees upon notice.
              Such notice will be provided at least 30 days before the change takes effect.
            </p>
          </div>

          <div class="section">
            <h2>4. Data Usage and Privacy</h2>
            <p>
              Our collection and use of personal information is governed by our
              <a routerLink="/privacy-policy">Privacy Policy</a>.
            </p>
          </div>

          <div class="section">
            <h2>5. Intellectual Property</h2>
            <p>
              All content, features, and functionality of our services are owned by
              Industry Intelligence and are protected by international copyright,
              trademark, and other intellectual property laws.
            </p>
          </div>

          <div class="section">
            <h2>6. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Industry Intelligence shall not
              be liable for any indirect, incidental, special, consequential, or
              punitive damages, or any loss of profits or revenues.
            </p>
          </div>

          <div class="section">
            <h2>7. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. We will notify
              you of any material changes by posting the new Terms on this page and
              updating the "Last Updated" date above.
            </p>
          </div>

          <div class="section">
            <h2>8. Contact Information</h2>
            <p>
              For any questions about these Terms, please contact us at:
              <a href="mailto:legal@industryintelligence.com">legal&#64;industryintelligence.com</a>
            </p>
          </div>
        </div>

        <div class="acceptance">
          <p>
            By using our services, you acknowledge that you have read and understood
            these Terms and agree to be bound by them.
          </p>
        </div>
      </div>
    </section>
  `,
  styles: [`
    .terms {
      padding: 3rem 0;
      background: var(--background-light);
    }

    .container {
      max-width: 900px;
      margin: 0 auto;
      padding: 0 1rem;
    }

    .page-header {
      text-align: center;
      margin-bottom: 3rem;
    }

    h1 {
      font-size: 2.5rem;
      color: var(--text-primary);
      margin-bottom: 0.5rem;
    }

    .last-updated {
      color: var(--text-secondary);
      font-style: italic;
    }

    .content {
      background: white;
      padding: 2rem;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .section {
      margin-bottom: 2rem;
      padding-bottom: 2rem;
      border-bottom: 1px solid var(--border-color);
    }

    .section:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }

    h2 {
      font-size: 1.5rem;
      color: var(--text-primary);
      margin-bottom: 1rem;
    }

    h3 {
      font-size: 1.25rem;
      color: var(--text-primary);
      margin: 1.5rem 0 1rem;
    }

    p {
      color: var(--text-secondary);
      line-height: 1.6;
      margin-bottom: 1rem;
    }

    ul {
      list-style: disc;
      margin-left: 1.5rem;
      margin-bottom: 1rem;
    }

    li {
      color: var(--text-secondary);
      line-height: 1.6;
      margin-bottom: 0.5rem;
    }

    a {
      color: var(--primary-color);
      text-decoration: none;
      transition: color 0.2s;
    }

    a:hover {
      color: var(--primary-color-dark);
      text-decoration: underline;
    }

    .acceptance {
      margin-top: 2rem;
      padding: 1.5rem;
      background: var(--primary-color-light);
      border-radius: 8px;
      text-align: center;
    }

    .acceptance p {
      color: var(--text-primary);
      margin: 0;
      font-weight: 500;
    }

    @media (max-width: 768px) {
      .content {
        padding: 1.5rem;
      }

      h1 {
        font-size: 2rem;
      }

      h2 {
        font-size: 1.25rem;
      }

      h3 {
        font-size: 1.1rem;
      }
    }
  `]
})
export class TermsComponent {
  lastUpdated = new Date('2024-02-24');
} 